var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1651 7.4006L6.01737 2.25287C5.68542 1.92092 5.14723 1.92092 4.81528 2.25287C4.48334 2.58481 4.48334 3.123 4.81528 3.45495L9.36198 8.00164L4.81528 12.5483C4.48334 12.8803 4.48334 13.4185 4.81528 13.7504C5.14723 14.0824 5.68542 14.0824 6.01737 13.7504L11.1651 8.60268C11.497 8.27074 11.497 7.73255 11.1651 7.4006Z",
    fill: "#007A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.7ccff498c4755383e488b29ea0d84182.svg";
export { ForwardRef as ReactComponent };